function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "OfficeDraw",
  transform: "translate(-57.579 2.308)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_76",
  "data-name": "Caminho 76",
  d: "M366.6,206.142h1.2l0-40.85c.089-9.124,5.424-13.376,11.825-13.642l84.956-.133c5.068.266,10.492,4.163,10.492,13.465l-.141,206.069c-.149,2.994-2.988,10.33-10.607,10.294H379.907c-7.171-.114-12.4-5.054-12.4-13.138l.288-137.442h-1.2Z",
  transform: "translate(-309.021 -153.824)",
  fill: "#222d3c"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_100",
  "data-name": "Caminho 100",
  d: "M412.7,95.605V301.373a9.25,9.25,0,0,1-9.247,9.241H319.918a9.231,9.231,0,0,1-9.247-9.241V95.605a9.247,9.247,0,0,1,9.248-9.247h12.5v1.6a7.615,7.615,0,0,0,7.613,7.616h42.486a7.552,7.552,0,0,0,4.514-1.486,7.075,7.075,0,0,0,.749-.629,7.592,7.592,0,0,0,2.349-5.5v-1.6h13.323a9.244,9.244,0,0,1,9.247,9.247Z",
  transform: "translate(-249.343 -86.066)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_9",
  "data-name": "Elipse 9",
  cx: 2.222,
  cy: 2.222,
  r: 2.222,
  transform: "translate(82.377 32.354)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_101",
  "data-name": "Caminho 101",
  d: "M551.97,108.738a7.081,7.081,0,0,1-.749.629,39.759,39.759,0,0,0,25.669,19.107v-.99A38.823,38.823,0,0,1,551.97,108.738Z",
  transform: "translate(-413.532 -101.342)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_102",
  "data-name": "Caminho 102",
  d: "M491.532,115.4h-1.041a57.67,57.67,0,0,0,44.947,35.887V150.3A56.68,56.68,0,0,1,491.532,115.4Z",
  transform: "translate(-372.08 -105.888)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_103",
  "data-name": "Caminho 103",
  d: "M431.194,115.4h-1a76.038,76.038,0,0,0,64.089,54.321v-.968A75.071,75.071,0,0,1,431.194,115.4Z",
  transform: "translate(-330.922 -105.888)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_104",
  "data-name": "Caminho 104",
  d: "M263.7,158.578h-.578V158H263v.578h-.579v.113H263v.578h.113v-.578h.578Z",
  transform: "translate(-186.398 -107.552)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_105",
  "data-name": "Caminho 105",
  d: "M386.7,67.578h-.578V67H386v.578h-.579v.113H386v.578h.113v-.578h.578Z",
  transform: "translate(-270.352 -45.439)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_106",
  "data-name": "Caminho 106",
  d: "M281.7,230.578h-.578V230H281v.578h-.579v.113H281v.578h.113v-.578h.578Z",
  transform: "translate(-198.684 -156.696)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_107",
  "data-name": "Caminho 107",
  d: "M365.7,177.578h-.578V177H365v.578h-.579v.113H365v.578h.113v-.578h.578Z",
  transform: "translate(-256.018 -120.521)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_108",
  "data-name": "Caminho 108",
  d: "M485.7,210.578h-.578V210H485v.578h-.579v.113H485v.578h.113v-.578h.578Z",
  transform: "translate(-337.925 -143.045)",
  fill: "#f2f2f2"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_10",
  "data-name": "Elipse 10",
  cx: 1.27,
  cy: 1.27,
  r: 1.27,
  transform: "translate(139.835 38.703)",
  fill: "#ff6584"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_109",
  "data-name": "Caminho 109",
  d: "M417.132,305.158l-.721.111c.225,1.441.4,2.914.533,4.371l.727-.063C417.541,308.1,417.36,306.615,417.132,305.158Z",
  transform: "translate(-321.517 -235.409)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_110",
  "data-name": "Caminho 110",
  d: "M410.969,277.818l-.7.213c.422,1.4.8,2.828,1.121,4.254l.714-.162C411.779,280.681,411.395,279.234,410.969,277.818Z",
  transform: "translate(-317.326 -216.748)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_111",
  "data-name": "Caminho 111",
  d: "M401.134,251.6l-.663.3c.609,1.33,1.181,2.7,1.7,4.06l.682-.257C402.328,254.325,401.754,252.941,401.134,251.6Z",
  transform: "translate(-310.637 -198.852)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_112",
  "data-name": "Caminho 112",
  d: "M387.837,227.018l-.616.39c.784,1.232,1.536,2.508,2.235,3.787l.641-.349C389.392,229.551,388.63,228.262,387.837,227.018Z",
  transform: "translate(-301.593 -182.074)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_113",
  "data-name": "Caminho 113",
  d: "M371.307,204.488l-.556.473c.946,1.111,1.867,2.273,2.736,3.447l.584-.435C373.2,206.786,372.265,205.612,371.307,204.488Z",
  transform: "translate(-290.351 -166.697)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_114",
  "data-name": "Caminho 114",
  d: "M351.877,184.428l-.486.543c1.092.975,2.162,2,3.181,3.044l.524-.511C354.064,186.447,352.981,185.412,351.877,184.428Z",
  transform: "translate(-277.137 -153.004)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_115",
  "data-name": "Caminho 115",
  d: "M329.921,167.208l-.41.6c1.213.816,2.413,1.686,3.565,2.584l.451-.575C332.358,168.913,331.146,168.033,329.921,167.208Z",
  transform: "translate(-262.203 -141.251)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_116",
  "data-name": "Caminho 116",
  d: "M310.671,155.248v.825c.759.4,1.511.813,2.247,1.238l.365-.632Q312,155.937,310.671,155.248Z",
  transform: "translate(-249.343 -133.087)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_117",
  "data-name": "Caminho 117",
  d: "M418.161,516.53c.118-.71.227-1.435.322-2.154l.724.1c-.1.727-.206,1.46-.326,2.178Z",
  transform: "translate(-322.711 -378.212)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_118",
  "data-name": "Caminho 118",
  d: "M411.752,539.01l.7.217c.438-1.411.834-2.856,1.177-4.3l-.711-.168C412.576,536.188,412.187,537.615,411.752,539.01Z",
  transform: "translate(-318.337 -392.128)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_119",
  "data-name": "Caminho 119",
  d: "M401.71,565.274l.662.31c.63-1.336,1.219-2.712,1.754-4.09l-.681-.266C402.917,562.592,402.333,563.953,401.71,565.274Z",
  transform: "translate(-311.482 -410.192)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_120",
  "data-name": "Caminho 120",
  d: "M388.2,590.095l.612.4c.807-1.238,1.582-2.521,2.3-3.812l-.637-.357C389.766,587.6,389,588.868,388.2,590.095Z",
  transform: "translate(-302.26 -427.319)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_121",
  "data-name": "Caminho 121",
  d: "M371.482,612.988l.553.479c.971-1.12,1.913-2.285,2.805-3.463l-.585-.437C373.376,610.732,372.444,611.882,371.482,612.988Z",
  transform: "translate(-290.85 -443.185)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_122",
  "data-name": "Caminho 122",
  d: "M351.907,633.51l.481.549c1.116-.974,2.208-2,3.251-3.045l-.516-.517C354.091,631.53,353.009,632.543,351.907,633.51Z",
  transform: "translate(-277.489 -457.471)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_123",
  "data-name": "Caminho 123",
  d: "M329.855,651.3l.4.611c1.233-.814,2.457-1.681,3.631-2.575l-.441-.583C332.285,649.642,331.076,650.5,329.855,651.3Z",
  transform: "translate(-262.437 -469.934)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_124",
  "data-name": "Caminho 124",
  d: "M313.366,664.65c-.883.5-1.784.981-2.7,1.438v-.819c.787-.4,1.568-.822,2.333-1.251Z",
  transform: "translate(-249.343 -480.351)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_125",
  "data-name": "Caminho 125",
  d: "M418.836,333.436l.73-.013c.013.737.014,1.478,0,2.2l-.73-.011C418.85,334.9,418.849,334.164,418.836,333.436Z",
  transform: "translate(-323.172 -254.701)",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_16",
  "data-name": "Elipse 16",
  cx: 39.646,
  cy: 39.646,
  r: 39.646,
  transform: "translate(73.378 75.567)",
  fill: "#6c63ff",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_17",
  "data-name": "Elipse 17",
  cx: 27.92,
  cy: 27.92,
  r: 27.92,
  transform: "translate(85.104 87.294)",
  fill: "#6c63ff",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_18",
  "data-name": "Elipse 18",
  cx: 18.427,
  cy: 18.427,
  r: 18.427,
  transform: "translate(94.597 96.786)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_130",
  "data-name": "Caminho 130",
  d: "M412.851,411.891a1.315,1.315,0,1,0-2.146,1.019l-.484,3.391h2.631l-.485-3.391A1.312,1.312,0,0,0,412.851,411.891Z",
  transform: "translate(-298.511 -294.629)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_131",
  "data-name": "Caminho 131",
  d: "M695.128,136.04s-7.08-6.347-16.6,5.615-24.413,17.821-27.83,22.46c0,0,14.159-5.859,19.042-8.3s4.638-1.953,4.638-1.953-6.591,4.638-7.812,9.277-.244,8.544-2.441,13.183,41.99,3.174,41.99,3.174,4.394-7.568,3.174-15.38S708.8,137.017,695.128,136.04Z",
  transform: "translate(-481.43 -118.829)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_132",
  "data-name": "Caminho 132",
  d: "M727.688,202.56s1.539,10.776-5.058,13.2-4.179,5.718-4.179,5.718l9.9,4.838,10.556-3.3,3.519-5.278s-5.718-1.32-4.179-5.278,1.979-5.278,1.979-5.278Z",
  transform: "translate(-527.38 -165.381)",
  fill: "#ffb9b9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_133",
  "data-name": "Caminho 133",
  d: "M727.688,202.56s1.539,10.776-5.058,13.2-4.179,5.718-4.179,5.718l9.9,4.838,10.556-3.3,3.519-5.278s-5.718-1.32-4.179-5.278,1.979-5.278,1.979-5.278Z",
  transform: "translate(-527.38 -165.381)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_134",
  "data-name": "Caminho 134",
  d: "M816.383,299.551s-1.54,20.233-1.1,21.113,0,31.449,0,31.449,3.079,16.494-.88,17.374-3.079-18.474-3.079-18.474L807.366,325.5l.44-25.291Z",
  transform: "translate(-588.365 -231.582)",
  fill: "#ffb9b9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_135",
  "data-name": "Caminho 135",
  d: "M816.383,299.551s-1.54,20.233-1.1,21.113,0,31.449,0,31.449,3.079,16.494-.88,17.374-3.079-18.474-3.079-18.474L807.366,325.5l.44-25.291Z",
  transform: "translate(-588.365 -231.582)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_136",
  "data-name": "Caminho 136",
  d: "M685.534,491.454s-7.257,27.49-7.037,40.906,3.079,32.109,3.079,32.109.44,8.137-.22,9.017,3.3,4.618,3.3,4.618l4.178-2.419,1.54-1.759v-1.54s-2.419-7.477-.44-13.415,3.079-20.893,1.1-25.511l13.635-40.466Z",
  transform: "translate(-500.401 -362.567)",
  fill: "#ffb9b9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_137",
  "data-name": "Caminho 137",
  d: "M668.323,748.106s-2.639-3.3-4.4-2.2-4.618,8.577-4.618,8.577-9.9,9.457-2.859,9.9,10.116-1.979,11-3.739,9.017-6.378,9.017-6.378-.88-8.357-2.2-8.577-3.3,3.3-3.3,3.3Z",
  transform: "translate(-483.63 -536.088)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_138",
  "data-name": "Caminho 138",
  d: "M769.57,482.81v27.271a84.306,84.306,0,0,0,.66,9.9c.66,4.838-3.739,40.906-3.739,40.906l.44,6.378,5.5-.44.66-5.5,7.917-24.192s2.639-14.735,1.32-20.233,6.818-40.686,6.818-40.686Z",
  transform: "translate(-560.466 -352.163)",
  fill: "#ffb9b9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_139",
  "data-name": "Caminho 139",
  d: "M761.329,752.755l1.629-.354s1.23-2.725,2.77-2.065a16.6,16.6,0,0,1,3.061,1.834l.678,1.245a26.286,26.286,0,0,0,3.519,5.5c1.979,2.2,4.178,7.038.88,7.477s-7.7.66-9.017-.44-.44-2.859-1.759-3.3-2.419-1.759-2.2-2.2S761.329,752.755,761.329,752.755Z",
  transform: "translate(-556.623 -539.197)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_19",
  "data-name": "Elipse 19",
  cx: 9.774,
  cy: 9.774,
  r: 9.774,
  transform: "translate(199.33 25.206)",
  fill: "#ffb9b9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_140",
  "data-name": "Caminho 140",
  d: "M718,247.489l2.9-1.014s-1.146,1.894,5.012,2.993,12.535,1.489,15.394-2.115c0,0,1.1-.525,2.639,1.015s2.419,1.1,2.419,1.1l-1.1,5.718-2.2,10.556-2.859,7.917-8.137-1.759-8.8-6.378-3.3-8.577v-7.917Z",
  transform: "translate(-527.365 -195.355)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_141",
  "data-name": "Caminho 141",
  d: "M721.183,252.329l2.2-1.539s7.477,1.32,7.917,4.838l-5.718,11a12.519,12.519,0,0,1-.22,9.457c-2.2,5.058-1.979,6.158-1.979,6.158l-1.539,6.6-27.93,2.2a19.788,19.788,0,0,0-1.539-3.079c-.44-.44-.44-1.979,0-1.979s0-.66-.44-1.32-.66-.88,0-1.759-1.1-8.8-1.1-8.8v-8.577l-7.477-9.9s2.639-3.959,3.959-4.4,7.6-2.174,7.6-2.174l1.42,2.091,1.979,15.918,2.859,9.677,12.038-2.045,4.676-7.851,3.079-9.237Z",
  transform: "translate(-503.721 -197.116)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_142",
  "data-name": "Caminho 142",
  d: "M817.008,265.6l1.759,1.32s1.539,12.316,1.1,13.2-8.137,1.759-8.357,1.32S817.008,265.6,817.008,265.6Z",
  transform: "translate(-591.189 -208.412)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_143",
  "data-name": "Caminho 143",
  d: "M701.759,244.314l2.2,14.515s-1.979,21.552-1.539,25.951l.44,1.32s-.88-.44-1.1.44a20.576,20.576,0,0,0,0,3.739s-1.32,1.32-1.759,8.577-5.718,24.631-3.739,25.291,13.855,3.959,20.233,3.3,29.25-8.357,29.03-10.336-11.216-29.91-11.216-29.91a28.9,28.9,0,0,1-1.979-3.739c0-.44,2.639-2.2,1.979-3.959s-4.179-20.233-4.179-20.233l2.419-13.2-3.3-.88L726.83,257.95s-9.457,4.618-19.353.44l-2.2-14.955Z",
  transform: "translate(-512.228 -193.28)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_144",
  "data-name": "Caminho 144",
  d: "M747.864,164.078s16.274,11.216,20.673,6.158-7.7-9.457-7.7-9.457l-10.116-1.1Z",
  transform: "translate(-547.752 -136.112)",
  fill: "#2f2e41"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_145",
  "data-name": "Caminho 145",
  d: "M586.1,516.154a8.58,8.58,0,1,0-2.691-3.341L560.965,531.5l-2.989-3.547-1.343.9-1.494-1.773,1.228-1.035-1.494-1.773-1.91,1.609.92,1.091-2.046,1.724-.92-1.091-3,2.529,1.379,1.637,1.091-.92,1.494,1.773-1.364,1.149,2.759,3.274L550,539.806l3.333,3.956Zm5.6-12.536a5.676,5.676,0,1,1-6.139,5.172,5.676,5.676,0,0,1,6.139-5.172Z",
  transform: "translate(-411.276 -368.871)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_146",
  "data-name": "Caminho 146",
  d: "M678.419,307.864s1.539,20.233,1.1,21.113,0,31.449,0,31.449-3.079,16.494.88,17.374,3.079-18.474,3.079-18.474l3.959-25.511L687,308.524Z",
  transform: "translate(-500.323 -237.256)",
  fill: "#ffb9b9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_147",
  "data-name": "Caminho 147",
  d: "M679.594,267.682l-1.759.66s-3.3,13.855-2.419,13.855,11.436,1.32,11.436.88-1.979-11.216-1.979-11.216Z",
  transform: "translate(-498.199 -209.83)",
  fill: "#6c63ff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Office",
  transform: "translate(103.068 102.83)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_33",
  "data-name": "Caminho 33",
  d: "M6.712,16.5H22.2a2.213,2.213,0,0,1,2.212,2.213v7.744A2.213,2.213,0,0,1,22.2,28.669H6.712A2.212,2.212,0,0,1,4.5,26.456V18.713A2.213,2.213,0,0,1,6.712,16.5Z",
  transform: "translate(-4.5 -6.538)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_34",
  "data-name": "Caminho 34",
  d: "M10.5,12.954V8.529A5.531,5.531,0,0,1,21.452,7.423",
  transform: "translate(-6.075 -2.992)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})));

var SvgOfficeDraw = function SvgOfficeDraw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175.719,
    height: 230.653,
    viewBox: "0 0 175.719 230.653",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOfficeDraw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Office-draw.b2bc6cee.svg";
export { ForwardRef as ReactComponent };